"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useOnScreen;

var _react = require("react");

function useOnScreen(ref) {
  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      isIntersecting = _ref3[0],
      setIntersecting = _ref3[1];

  var observer = new IntersectionObserver(function (_ref) {
    var _ref4 = _slicedToArray(_ref, 1),
        entry = _ref4[0];

    return setIntersecting(entry.isIntersecting);
  });
  (0, _react.useEffect)(function () {
    observer.observe(ref.current); // Remove the observer as soon as the component is unmounted

    return function () {
      observer.disconnect();
    };
  }, []);
  return isIntersecting;
}